import { Component, effect, inject, OnInit } from '@angular/core';
import { AlertComponent } from '../../atoms/alert/alert.component';
import { AlertStyleDirective } from '../../../directives/alert-style.directive';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DataLayerDataListComponent } from '../data-layer-data-list/data-layer-data-list.component';
import { DividerModule } from 'primeng/divider';
import { HeaderComponent } from '../../atoms/header/header.component';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { IndicatorDataStore } from '../../../stores/indicatpr-data/indicator-data.state';
import { DataLayer } from '../../../models/data-layer';
import { DataLayerStore } from '../../../stores/data-layer/data-layer.state';
import { DataLayerType } from '../../../models/data-layer-type';
import { ButtonModule } from 'primeng/button';
import { AccordionModule } from 'primeng/accordion';
import { BadgeModule } from 'primeng/badge';
import { DataLayerTypeStore } from '../../../stores/data-layer-type/data-layer-type.state';
import { getState } from '@ngrx/signals';

@Component({
  selector: 'app-confirm-delete-data-layer-type',
  standalone: true,
  imports: [
    AlertComponent,
    AlertStyleDirective,
    ButtonModule,
    ConfirmDialogModule,
    DataLayerDataListComponent,
    DividerModule,
    HeaderComponent,
    ScrollPanelModule,
    AccordionModule,
    BadgeModule,
  ],
  templateUrl: './confirm-delete-data-layer-type.component.html',
  styleUrl: './confirm-delete-data-layer-type.component.scss',
})
export class ConfirmDeleteDataLayerTypeComponent implements OnInit {
  readonly layerTypeStore = inject(DataLayerTypeStore);
  readonly indicatorDataStore = inject(IndicatorDataStore);
  readonly layerStore = inject(DataLayerStore);
  dataLayerTypeToDelete: DataLayerType | null = null;
  typeLayers: DataLayer[] = [];

  constructor() {
    effect(() => {
      const typeState = getState(this.layerTypeStore);
      this.dataLayerTypeToDelete = this.layerTypeStore.selectedItem();
      this.checkForData();
    });
  }

  /**
   * Angular lifecycle hook that is called after the component's view has been initialized.
   * Typically used to perform initialization logic, such as data retrieval or setup tasks.
   *
   * @return {void} No return value as this method is primarily intended for initialization purposes.
   */
  ngOnInit(): void {
    this.checkForData();
  }

  /**
   * Checks for the presence of a specific data layer type to delete and filters type layers by its parent ID.
   * Updates the typeLayers property with the filtered results.
   *
   * @return {void} This method does not return a value.
   */
  checkForData(): void {
    if (!this.dataLayerTypeToDelete) return;
    this.typeLayers = this.layerStore.filterByParent(
      this.dataLayerTypeToDelete._id
    );
  }
}
